const APP_RETURN_TIMEOUT = 5000;
export default APP_RETURN_TIMEOUT;
